import { render, staticRenderFns } from "./LitPaper.vue?vue&type=template&id=1d3cc0e4&scoped=true&"
import script from "./LitPaper.vue?vue&type=script&lang=js&"
export * from "./LitPaper.vue?vue&type=script&lang=js&"
import style0 from "./LitPaper.vue?vue&type=style&index=0&id=1d3cc0e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3cc0e4",
  null
  
)

export default component.exports